let toastEl: HTMLDivElement | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;

export function mountToast(): HTMLDivElement {
  if (toastEl) {
    return toastEl;
  }
  toastEl = document.createElement("div");
  toastEl.id = "toast";
  toastEl.className = "toast";
  toastEl.hidden = true;
  document.body.appendChild(toastEl);
  return toastEl;
}

export function toast(message: string): void {
  const el = mountToast();
  el.textContent = message;
  el.hidden = false;
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    el.hidden = true;
  }, 2600);
}

export function esc(value: unknown): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
